// Markups (დანარიცხები): each one has a place — "sheet" (bottom of every Hard Cost sheet) or
// "total" (the object's TOTAL) — and is applied to the running total before it.
// Markup: { k, name, pct, on, at: "sheet" | "total" }

/**
 * Lines as Excel writes them for one place: ჯამი, markup, ჯამი, markup, ჯამი …
 * Returns { lines: [{ kind: "sum" | "markup", name, pct?, amount }], total }.
 */
export function markupChain(base, markups, at) {
  let running = Number(base) || 0;
  const lines = [{ kind: "sum", name: "ჯამი", amount: running }];
  markups
    .filter((m) => m.on && m.at === at)
    .forEach((m) => {
      const pct = Number(String(m.pct).replace(",", ".")) || 0;
      const amount = (running * pct) / 100;
      running += amount;
      lines.push({ kind: "markup", name: m.name, pct, amount });
      lines.push({ kind: "sum", name: "ჯამი", amount: running });
    });
  return { lines, total: running };
}

/** Factor that "built into price" multiplies unit prices by (sheet markups only). */
export function builtInFactor(markups) {
  return markupChain(1, markups, "sheet").total;
}
